import BSpinner from 'react-bootstrap/Spinner';

// Inline loading indicator. Picks up the current text color via Bootstrap's
// currentColor handling, so it works in both light and dark themes.
export const Spinner = ({ label = 'Loading…' }) => (
  <BSpinner
    as="span"
    animation="border"
    size="sm"
    role="status"
    aria-hidden="false"
  >
    <span className="visually-hidden">{label}</span>
  </BSpinner>
);
